import React, { useState } from 'react';
import { JSONSchema7 } from 'json-schema';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { Text } from 'src/modules/shared/components/atoms/text';
import { PiPlus, PiTrash } from 'react-icons/pi';
import {
  buildMergedAnyOfValue,
  getEmptyValueForSchema,
  isJsonSchema,
} from 'src/modules/shared/utils/json-schema.util';
import { FormFieldProps } from 'src/modules/shared/types/json-schema.type';
import { ArrayItemSchemaFields } from './array-item-schema-fields';

/**
 * Props for ArrayField component
 */
export interface ArrayFieldProps extends FormFieldProps {
  value: unknown[];
}

export const ArrayField: React.FC<ArrayFieldProps> = ({
  fieldKey,
  schema,
  value = [],
  handleChange,
  disabled = false,
  allFieldsOptional = false,
  JSONSchemaForm,
}) => {
  const [anyOfSelections, setAnyOfSelections] = useState<
    Record<string, number>
  >({});

  const itemSchema = schema.items as JSONSchema7;
  if (!itemSchema) return null;

  return (
    <div className="space-y-3">
      {value.map((item, index) => (
        <div key={index} className="flex gap-2 items-start">
          <div className="flex-grow">
            <div className="p-3 border rounded-md bg-gray-50">
              <ArrayItemSchemaFields
                parentKey={fieldKey}
                index={index}
                itemSchema={itemSchema}
                itemValue={item}
                arrayValue={value}
                handleChange={handleChange}
                disabled={disabled}
                allFieldsOptional={allFieldsOptional}
                anyOfSelections={anyOfSelections}
                setAnyOfSelections={setAnyOfSelections}
                JSONSchemaForm={JSONSchemaForm}
              />
            </div>
          </div>
          <Button
            variant="danger"
            appearance="outline"
            size="sm"
            onClick={(e) => {
              e.preventDefault();
              const newArray = [...value];
              newArray.splice(index, 1);
              handleChange(fieldKey, newArray);
            }}
            className="mt-2"
            type="button"
          >
            <PiTrash className="w-4 h-4" />
          </Button>
        </div>
      ))}
      <Button
        variant="primary"
        appearance="outline"
        size="sm"
        onClick={(e) => {
          e.preventDefault();
          const union = itemSchema.anyOf || itemSchema.oneOf;
          const emptyValue =
            Array.isArray(union) && union.length > 0
              ? buildMergedAnyOfValue(
                  isJsonSchema(union[0]) ? union[0] : undefined,
                  undefined
                )
              : getEmptyValueForSchema(itemSchema);
          handleChange(fieldKey, [...value, emptyValue]);
        }}
        className="mt-2 flex items-center gap-1"
        type="button"
      >
        <PiPlus className="w-4 h-4" />
        <Text size="small" color="primary">
          {/* TODO: check when implementing i18n */}
          Agregar item
        </Text>
      </Button>
    </div>
  );
};
